var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("p", { staticClass: "title is-4" }, [
        _vm._v("\n    " + _vm._s(_vm.exhibitorSuite.name) + " "),
        _c("br"),
        _vm._v(" "),
        _vm.exhibitorSuite.company &&
        _vm.exhibitorSuite.company.name !== _vm.exhibitorSuite.name
          ? _c("span", { staticClass: "title is-6" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.exhibitorSuite.company.name) + "\n    "
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Below are the appointment times available for " +
            _vm._s(_vm.exhibitorSuite.name) +
            ".\n    Click on "
        ),
        _c("b", [_vm._v("Request Appointment")]),
        _vm._v(
          " to request an appointment for a\n    specific date and time. The company contact will receive an e-mail with\n    your request.\n  "
        )
      ]),
      _vm._v(" "),
      _vm._l(_vm.sortedActiveScheduleKeys, function(meetingDate) {
        return _c("section", { key: meetingDate, staticClass: "my-8" }, [
          _c("h3", { staticClass: "subtitle is-5" }, [
            _vm._m(0, true),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.formatDate(meetingDate)))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "box" }, [
            _c("table", { staticClass: "table is-hoverable is-fullwidth" }, [
              _vm._m(1, true),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.activeSchedule[meetingDate], function(
                  timeslot,
                  timeslotIdx
                ) {
                  return timeslot.is_open ||
                    _vm.hasWriteableSlotAvailable(timeslot)
                    ? _c("tr", { key: timeslotIdx }, [
                        _c("td", { attrs: { width: "250" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                timeslot.start_time + " - " + timeslot.end_time
                              ) +
                              "\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          _vm._l(_vm.userWriteableSuites, function(
                            userSuite,
                            userSuiteKey
                          ) {
                            return _c("span", { key: userSuiteKey }, [
                              timeslot.pending.findIndex(function(item) {
                                return (
                                  item.suiteId === userSuiteKey &&
                                  item.type == "from"
                                )
                              }) < 0 &&
                              _vm.isTimeslotOpen(
                                timeslot.id,
                                userSuite.appointment_slots
                              )
                                ? _c("p", { staticClass: "request-line" }, [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "button is-small is-primary is-outlined",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.confirmRequestAppointment(
                                              userSuiteKey,
                                              timeslot,
                                              meetingDate
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._m(2, true),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v("Request Appointment")
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    Object.keys(_vm.userWriteableSuites)
                                      .length > 1
                                      ? _c("span", [
                                          _vm._v("for "),
                                          _c("b", [
                                            _vm._v(_vm._s(userSuite.name))
                                          ])
                                        ])
                                      : _vm._e()
                                  ])
                                : timeslot.pending.findIndex(function(item) {
                                    return (
                                      item.suiteId === userSuiteKey &&
                                      item.type == "from"
                                    )
                                  }) >= 0
                                ? _c("p", { staticClass: "request-line" }, [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "button is-small is-danger is-outlined",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.confirmCancelRequest(
                                              userSuiteKey,
                                              timeslot,
                                              meetingDate
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._m(3, true),
                                        _vm._v(" "),
                                        _c("span", [_vm._v("Cancel Request")])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    Object.keys(_vm.userWriteableSuites)
                                      .length > 1
                                      ? _c("span", [
                                          _vm._v("for "),
                                          _c("b", [
                                            _vm._v(_vm._s(userSuite.name))
                                          ])
                                        ])
                                      : _vm._e()
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.myOtherPendingRequests(meetingDate, timeslot)
                                .length
                                ? _c(
                                    "div",
                                    { staticClass: "mt-2" },
                                    [
                                      _vm._m(4, true),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.myOtherPendingRequests(
                                          meetingDate,
                                          timeslot
                                        ),
                                        function(item) {
                                          return _c("p", {
                                            key: item.suiteId,
                                            domProps: {
                                              innerHTML: _vm._s(item.message)
                                            }
                                          })
                                        }
                                      )
                                    ],
                                    2
                                  )
                                : _vm._e()
                            ])
                          }),
                          0
                        )
                      ])
                    : _vm._e()
                }),
                0
              )
            ])
          ])
        ])
      }),
      _vm._v(" "),
      _vm.showConfirmRequestModal
        ? _c(
            "modal",
            {
              attrs: {
                title: "Request Appointment",
                "show-close-button": false
              }
            },
            [
              _c("table", [
                _c("tbody", [
                  _c("tr", [
                    _c("td", [_vm._v("With:")]),
                    _vm._v(" "),
                    _c("td", { staticClass: "pl-4" }, [
                      _c("strong", [_vm._v(_vm._s(_vm.exhibitorSuite.name))])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("Date:")]),
                    _vm._v(" "),
                    _c("td", { staticClass: "pl-4" }, [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.formatDate(
                              _vm.requestAppointmentData.meetingDate
                            )
                          )
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("Time:")]),
                    _vm._v(" "),
                    _c("td", { staticClass: "pl-4" }, [
                      _c("strong", [
                        _vm._v(
                          _vm._s(_vm.requestAppointmentData.timeslot.start_time)
                        )
                      ])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field mt-4" }, [
                _c("div", { staticClass: "control" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.requestAppointmentData.notes,
                        expression: "requestAppointmentData.notes"
                      }
                    ],
                    staticClass: "textarea",
                    attrs: {
                      placeholder: "Include an optional note with the request"
                    },
                    domProps: { value: _vm.requestAppointmentData.notes },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.requestAppointmentData,
                          "notes",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "button is-primary",
                    class: {
                      "is-loading": _vm.requestAppointmentData.isLoading
                    },
                    attrs: {
                      type: "button",
                      disabled: _vm.requestAppointmentData.isLoading
                    },
                    on: { click: _vm.requestAppointment }
                  },
                  [_vm._v("\n        Send Request\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "button",
                    attrs: {
                      type: "button",
                      disabled: _vm.requestAppointmentData.isLoading
                    },
                    on: {
                      click: function($event) {
                        _vm.showConfirmRequestModal = false
                      }
                    }
                  },
                  [_vm._v("\n        Nevermind\n      ")]
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showConfirmCancelModal
        ? _c(
            "modal",
            {
              attrs: {
                title: "Cancel the Appointment Request",
                "show-close-button": false
              }
            },
            [
              _c("table", [
                _c("tbody", [
                  _c("tr", [
                    _c("td", [_vm._v("With:")]),
                    _vm._v(" "),
                    _c("td", { staticClass: "pl-4" }, [
                      _c("strong", [_vm._v(_vm._s(_vm.exhibitorSuite.name))])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("Date:")]),
                    _vm._v(" "),
                    _c("td", { staticClass: "pl-4" }, [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.formatDate(
                              _vm.cancelAppointmentData.meetingDate
                            )
                          )
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("Time:")]),
                    _vm._v(" "),
                    _c("td", { staticClass: "pl-4" }, [
                      _c("strong", [
                        _vm._v(
                          _vm._s(_vm.cancelAppointmentData.timeslot.start_time)
                        )
                      ])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field mt-4" }, [
                _c("div", { staticClass: "control" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.cancelAppointmentData.notes,
                        expression: "cancelAppointmentData.notes"
                      }
                    ],
                    staticClass: "textarea",
                    attrs: {
                      placeholder:
                        "Include an optional note with the cancelation"
                    },
                    domProps: { value: _vm.cancelAppointmentData.notes },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.cancelAppointmentData,
                          "notes",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "button is-danger",
                    class: {
                      "is-loading": _vm.cancelAppointmentData.isLoading
                    },
                    attrs: {
                      type: "button",
                      disabled: _vm.cancelAppointmentData.isLoading
                    },
                    on: { click: _vm.cancelAppointment }
                  },
                  [_vm._v("\n        Cancel Request\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "button",
                    attrs: {
                      type: "button",
                      disabled: _vm.cancelAppointmentData.isLoading
                    },
                    on: {
                      click: function($event) {
                        _vm.showConfirmCancelModal = false
                      }
                    }
                  },
                  [_vm._v("\n        Nevermind\n      ")]
                )
              ])
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "far fa-calendar" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [_c("th", [_vm._v("Time Slot")]), _vm._v(" "), _c("th")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "far fa-calendar-plus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "far fa-calendar-times" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("strong", [_vm._v("Other requests for this time:")])])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-728c9639", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-728c9639","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ExhibitorSchedule.vue
// module id = null
// module chunks = 